import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-76b4df9d")
const _hoisted_1 = { class: "breeding data-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "data-list__title" }, "Breeding", -1)
const _hoisted_3 = { class: "data-list__info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "data-list__info-title" }, "Egg Groups", -1)
const _hoisted_5 = { class: "breeding__egg-groups" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "data-list__info" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "data-list__info-title" }, "Gender", -1)
const _hoisted_9 = { class: "breeding__gender" }
const _hoisted_10 = { class: "breeding__male" }
const _hoisted_11 = { class: "breeding__female" }
const _hoisted_12 = { class: "data-list__info" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "data-list__info-title" }, "Hatching Steps", -1)
const _hoisted_14 = { class: "breeding__hatching-steps" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eggGroups, (group, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "breeding__egg-group",
            key: index
          }, [
            _createTextVNode(_toDisplayString(group) + " ", 1),
            (index !== _ctx.eggGroups.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, ", "))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.gender.male) + "% ♂", 1),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.gender.female) + "% ♀", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.hatchingSteps), 1)
    ])
  ]))
}